@if (headline || anchor) {
  <div class="section-headline-wrapper {{ theme }}">
    @if (anchor) {
      <div [mbScrollSpy]="anchor"></div>
    }
    @if (headline) {
      <div class="section-headline-container" [ngClass]="containerClass">
        <div>
          <span class="section-headline-dash"></span>
          <h2>{{ headline }}</h2>
        </div>
        <ng-content></ng-content>
      </div>
    }
  </div>
}
